import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewNottificationsList = () => { 
    return useQuery({ 
        queryKey: ['viewNottificationsList'], 
        queryFn: async () => {  
            const res = await api.get('/list-nottification', {
            }); 
            return res.data; 
        }
     });
};  